import React, {Component} from 'react';
import {Grid, Row, Col, Tabs, Tab} from "react-bootstrap";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import Links from "../../../../utilities/linksConfig/Links";
import KonfiguracjaService from "../../../administracja/konfiguracja/KonfiguracjaService";
import TrasyService from "../../trasyConfig/trasy/TrasyService";
import moment from 'moment'
import DateAndTimeFormat from "../../../../utilities/DateAndTimeFormat";
import SprawdzKonfiguracjeZakladkaRozklad from "./SprawdzKonfiguracjeZakladkaRozklad";
import SprawdzKonfiguracjeZakladkaCennik from "./SprawdzKonfiguracjeZakladkaCennik";

export default class SprawdzKonfiguracjeContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            start: DateAndTimeFormat.formatYYYYMMDD(moment()),
            koniec: DateAndTimeFormat.formatYYYYMMDD(moment()),
            trasy: [],
            activeTab: 1,
        };
        this.changeActiveTab = this.changeActiveTab.bind(this)
    }

    componentDidMount() {
        this.pobierzDatyOkresowe()
        this.pobierzTrasy()
    }

    pobierzDatyOkresowe() {

        KonfiguracjaService.pobierzWartoscStartRozkladu().then(function (responseStart) {
            KonfiguracjaService.pobierzWartoscKoniecRozkladu().then(function (responseKoniec) {
                let start = responseStart.data;
                let koniec = responseKoniec.data;

                this.setState({
                    start: start,
                    koniec: koniec,
                })
            }.bind(this))
        }.bind(this))

    }

    pobierzTrasy() {
        TrasyService.getTrasy().then(function (response) {
            this.setState({trasy: response.data.content})
        }.bind(this))
    }

    renderContent() {
        if (this.state.activeTab === 1) {
            return <SprawdzKonfiguracjeZakladkaRozklad start={this.state.start} koniec={this.state.koniec} trasy={this.state.trasy}/>
        }
        else {
            return <SprawdzKonfiguracjeZakladkaCennik start={this.state.start} koniec={this.state.koniec} />
        }
    }

    changeActiveTab(eventKey) {
        this.setState({activeTab: eventKey})
    }


    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'RozkladContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/konfiguracja', text: 'Konfiguracja'}, {
                                    addressUrl: '/konfiguracja/rozklad-jazdy',
                                    text: 'Rozkład jazdy'
                                }, {addressUrl: '/konfiguracja/rozklad-jazdy/sprawdz', text: 'Sprawdź konfigurację'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <Tabs defaultActiveKey={1} id="ekipy-tab" onSelect={this.changeActiveTab}>
                                <Tab eventKey={1} title="Konfiguracja rozkładu">
                                </Tab>
                                <Tab eventKey={2} title="Konfiguracja cenników">
                                </Tab>
                            </Tabs>
                        </Col>
                        <Col sm={12}>
                            <div style={{marginTop: '15px'}}>
                                {this.renderContent()}
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/sprawdzKonfiguracje/SprawdzKonfiguracjeContainer.js